import { h, Fragment, Component } from "preact";
import { assert } from "../utils/asserts";
import { AppContext } from "./app_context";

export class AppError extends Error {
  constructor(readonly type: AppErrorType) {
    super();
  }
}

export enum AppErrorType {
  PAGE_NOT_FOUND,
}

interface Props {
  errorType: AppErrorType;
}

export class AppErrorComponent extends Component<Props> {
  static contextType = AppContext;

  componentDidMount() {
    (this.context as AppContext).reportAppError(this.props.errorType);
  }

  componentWillUnmount() {}

  render() {
    return <></>;
  }
}
